import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import RadBotNodesComponent from "../components/radbot-nodes/RadBotNodesComponent";

const RadBotNodesPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Rad Bots"
        routes={[{ title: "Home", path: "/" }]}
      />
      <RadBotNodesComponent />
    </>
  );
};
export default RadBotNodesPage;
